import { render } from "./home-image.vue?vue&type=template&id=2e482f83"
import script from "./home-image.vue?vue&type=script&lang=js"
export * from "./home-image.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__